import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Lots_ds_find_vendorlotsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number, lookupcode?: string, expirationDate?: string, manufactureDate?: string, materialId?: number, lotId?: number }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, MaterialId?: number, Vat?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Lots/datasources/ds_find_vendorlots/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, lookupcode?: string, expirationDate?: string, manufactureDate?: string, materialId?: number, lotId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, MaterialId?: number, Vat?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Lots/datasources/ds_find_vendorlots/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, lookupcode?: string, expirationDate?: string, manufactureDate?: string, materialId?: number, lotId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, MaterialId?: number, Vat?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_find_vendorlots/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number, lookupcode?: string, expirationDate?: string, manufactureDate?: string, materialId?: number, lotId?: number    }) {
      return false;
    }
}
